import Company from './components/Company';
import { CreditApplicationType } from 'src/utils/enums/financialTypes.enum';
import FormSectionPage from '../../ui/formSectionPage';
import Income from './components/Income';
import { useLocalization } from 'src/utils/useLocalization';
import {
    ADDRESS_NUMBER,
    ADDRESS_NUMBER2,
    validateCompanyName,
    validateJobMonth,
    validateJobYear,
    validateLengthNumber,
    validateRequired,
    validateZipCanada,
    validateZipUSA,
} from '../utils';
import { NUMBER_TWO, NUMBER_ZERO } from 'src/utils/constants';
import React, { useEffect, useState } from 'react';
import './style.scss';

export interface IIncome {
    type: string;
    frequency: string;
    amount: number | null;
    error?: boolean;
}

export interface IOccupation {
    retired: boolean;
    employed: boolean;
    selfEmployed: boolean;
    city: string;
    country: string;
    province: string;
    code: string;
    occupation: string;
    jobYear: number | null;
    jobMonth: number | null;
    address: string;
    addressSecondary: string;
    company: string;
    setErrorCompany: Function;
    setErrorAddress: Function;
    setErrorAddressSecondary: Function;
    setErrorCity: Function;
    setErrorCode: Function;
    setErrorOcuppation: Function;
    setErrorJobYear: Function;
    setErrorJobMonth: Function;
    preCity: string;
    preCountry: string;
    preProvince: string;
    preCode: string;
    preOccupation: string;
    preJobYear: number;
    preJobMonth: number;
    preAddress: string;
    preAddressSecondary: string;
    preCompany: string;
    setErrorPreCompany: Function;
    setErrorPreAddress: Function;
    setErrorPreAddressSecondary: Function;
    setErrorPreCity: Function;
    setErrorPreCode: Function;
    setErrorPreOcuppation: Function;
    setErrorPreJobYear: Function;
    setErrorPreJobMonth: Function;
}

interface IProps {
    applicationType: string;
    setIncomeData: Function;
    setCoincomeData: Function;
    setOccupationData: Function;
    setCooccupationData: Function;
    setIncomeValid: Function;
    isOpen: boolean;
    setOpen: Function;
    isBlocked?: boolean;
    initialPrimaryApplicant?: any;
    initialJointOrCoApplicant?: any;
    isEditMode?: boolean;
    disablePrintAndSubmitBtn: Function;
}

export const oc: IOccupation = {
    occupation: '',
    company: '',
    address: '',
    addressSecondary: '',
    city: '',
    country: 'USA',
    province: '',
    code: '',
    jobMonth: null,
    jobYear: null,
    retired: false,
    employed: false,
    selfEmployed: false,
    setErrorCompany: () => {
        return;
    },
    setErrorAddress: () => {
        return;
    },
    setErrorAddressSecondary: () => {
        return;
    },
    setErrorCity: () => {
        return;
    },
    setErrorCode: () => {
        return;
    },
    setErrorOcuppation: () => {
        return;
    },
    setErrorJobYear: () => {
        return;
    },
    setErrorJobMonth: () => {
        return;
    },
    preOccupation: '',
    preCompany: '',
    preAddress: '',
    preAddressSecondary: '',
    preCity: '',
    preCountry: 'USA',
    preProvince: '',
    preCode: '',
    preJobMonth: 0,
    preJobYear: 0,
    setErrorPreCompany: () => {
        return;
    },
    setErrorPreAddress: () => {
        return;
    },
    setErrorPreAddressSecondary: () => {
        return;
    },
    setErrorPreCity: () => {
        return;
    },
    setErrorPreCode: () => {
        return;
    },
    setErrorPreOcuppation: () => {
        return;
    },
    setErrorPreJobYear: () => {
        return;
    },
    setErrorPreJobMonth: () => {
        return;
    },
};

const IndividualOccupationIncome = ({
    applicationType,
    setIncomeData,
    setCoincomeData,
    setOccupationData,
    setCooccupationData,
    setIncomeValid,
    isOpen,
    setOpen,
    isBlocked = false,
    initialPrimaryApplicant = null,
    initialJointOrCoApplicant = null,
    isEditMode = false,
    disablePrintAndSubmitBtn,
}: IProps) => {
    const isJointOrCoApp =
        applicationType.includes(CreditApplicationType.JOINT) ||
        applicationType.includes(CreditApplicationType.COAPP);
    const [disabledForm, setDisabledForm] = useState<boolean>(false);
    const { occupationIndividualInformation } = useLocalization();
    const [validated, setValidated] = useState<boolean | null>(null);
    const [isIncomeSubmitted, setIsIncomeSubmitted] = useState<boolean>(false);

    const [incomes, setIncomes] = useState<IIncome[]>([]);
    const [coIncomes, setCoIncomes] = useState<IIncome[]>([]);
    const [occupationObject, setOccupationObject] = useState<IOccupation>(oc);
    const [coOccupation, setCoOccupation] = useState<IOccupation>(oc);
    const [isIncomeFieldValueUpdated, setIsIncomeFieldValueUpdated] =
        useState<boolean>(false);
    const [isOccupationFieldValueUpdated, setIsOccupationFieldValueUpdated] =
        useState<boolean>(false);
    const [isCoAppIncomeFieldValueUpdated, setIsCoAppIncomeFieldValueUpdated] =
        useState<boolean>(false);
    const [
        isCoAppOccupationFieldValueUpdated,
        setIsCoAppOccupationFieldValueUpdated,
    ] = useState<boolean>(false);

    function handlerChangeIncomes(value: any) {
        setIncomes(value);
    }

    function handlerChangeCompany(values: any) {
        setOccupationObject({ ...values });
    }

    function handlerChangeCoIncomes(value: any) {
        setCoIncomes(value);
    }

    function handlerChangeCoCompany(values: any) {
        setCoOccupation({ ...values });
    }

    function buildAndSetIncomeData() {
        if (isJointOrCoApp) {
            if (coIncomes.length) {
                if (!validaIncomes(coIncomes)) {
                    return;
                } else {
                    setCoincomeData(
                        coIncomes.map((income) => {
                            return {
                                typeOfIncome: income.type,
                                grossIncomeAmt: income.amount,
                                incomeFrequency: income.frequency,
                            };
                        }),
                    );
                }
            } else setValidated(false);
        }
        const incomeDataMapped = incomes.map((income) => {
            return {
                typeOfIncome: income.type,
                grossIncomeAmt: income.amount,
                incomeFrequency: income.frequency,
            };
        });
        setIncomeData(incomeDataMapped);
    }

    function buildAndSetOccupationData() {
        if (isJointOrCoApp) {
            let addressLine2;

            if (coOccupation.addressSecondary.trim()) {
                addressLine2 = coOccupation.addressSecondary.trim();
            }

            let address;

            if (
                coOccupation.address.trim() &&
                coOccupation.city.trim() &&
                coOccupation.code.trim()
            ) {
                address = {
                    addressLine1: coOccupation.address.trim(),
                    addressLine2,
                    city: coOccupation.city.trim(),
                    zipOrPostalCode: coOccupation.code.toUpperCase().trim(),
                    state: coOccupation.province,
                    country: coOccupation.country == 'USA' ? 'US' : 'CA',
                };
            }

            let employerName;

            if (coOccupation.company.trim()) {
                employerName = coOccupation.company.trim();
            }

            let occupation;

            if (coOccupation.occupation.trim()) {
                occupation = coOccupation.occupation.trim();
            }

            const coEmployerData: any = {
                current: {
                    address,
                    employerName,
                    occupation,
                    employmentType: selectEmploymentType(coOccupation),
                    timeAtJob: {
                        timeOnJobsMonths: coOccupation.jobMonth || NUMBER_ZERO,
                        timeOnJobsYears: coOccupation.jobYear || NUMBER_ZERO,
                    },
                },
            };

            // prev emp
            if (
                typeof coOccupation.jobYear === 'number' &&
                coOccupation.jobYear < NUMBER_TWO
            ) {
                let preAddressLine2;

                if (coOccupation.preAddressSecondary.trim()) {
                    preAddressLine2 = coOccupation.preAddressSecondary.trim();
                }

                let preAddress;

                if (
                    coOccupation.preAddress.trim() &&
                    coOccupation.preCity.trim() &&
                    coOccupation.preCode.trim()
                ) {
                    preAddress = {
                        addressLine1: coOccupation.preAddress.trim(),
                        addressLine2: preAddressLine2,
                        city: coOccupation.preCity.trim(),
                        zipOrPostalCode: coOccupation.preCode
                            .toUpperCase()
                            .trim(),
                        state: coOccupation.preProvince,
                        country: coOccupation.preCountry == 'USA' ? 'US' : 'CA',
                    };
                }

                let preEmployerName;

                if (coOccupation.preCompany.trim()) {
                    preEmployerName = coOccupation.preCompany.trim();
                }

                let preOccupation;

                if (coOccupation.preOccupation.trim()) {
                    preOccupation = coOccupation.preOccupation.trim();
                }
                coEmployerData.previous = {
                    address: preAddress,
                    employerName: preEmployerName,
                    occupation: preOccupation,
                    timeAtJob: {
                        timeOnJobsMonths: coOccupation.preJobMonth,
                        timeOnJobsYears: coOccupation.preJobYear,
                    },
                    employmentType: coEmployerData.current.employmentType,
                };
            }

            setCooccupationData(coEmployerData);
        }
        let addressLine2;
        if (occupationObject.addressSecondary.trim()) {
            addressLine2 = occupationObject.addressSecondary.trim();
        }

        let address;

        if (
            occupationObject.address.trim() &&
            occupationObject.city.trim() &&
            occupationObject.code.trim()
        ) {
            address = {
                addressLine1: occupationObject.address.trim(),
                addressLine2,
                city: occupationObject.city.trim(),
                zipOrPostalCode: occupationObject.code.toUpperCase().trim(),
                state: occupationObject.province,
                country: occupationObject.country == 'USA' ? 'US' : 'CA',
            };
        }

        let employerName;

        if (occupationObject.company.trim()) {
            employerName = occupationObject.company.trim();
        }

        let occupation;

        if (occupationObject.occupation.trim()) {
            occupation = occupationObject.occupation.trim();
        }
        const employerData: any = {
            current: {
                address,
                employerName,
                occupation,
                employmentType: selectEmploymentType(occupationObject),
                timeAtJob: {
                    timeOnJobsMonths: occupationObject.jobMonth || NUMBER_ZERO,
                    timeOnJobsYears: occupationObject.jobYear || NUMBER_ZERO,
                },
            },
        };
        // pre emp
        if (
            typeof occupationObject.jobYear === 'number' &&
            occupationObject.jobYear < NUMBER_TWO
        ) {
            let preAddressLine2;
            let preAddress;
            let preEmployerName;
            let preOccupation;

            if (occupationObject.preAddressSecondary.trim()) {
                preAddressLine2 = occupationObject.preAddressSecondary.trim();
            }
            if (
                occupationObject.preAddress.trim() &&
                occupationObject.preCity.trim() &&
                occupationObject.preCode.trim()
            ) {
                preAddress = {
                    addressLine1: occupationObject.preAddress.trim(),
                    addressLine2: preAddressLine2,
                    city: occupationObject.preCity.trim(),
                    zipOrPostalCode: occupationObject.preCode
                        .toUpperCase()
                        .trim(),
                    state: occupationObject.preProvince,
                    country: occupationObject.preCountry == 'USA' ? 'US' : 'CA',
                };
            }
            if (occupationObject.preCompany.trim()) {
                preEmployerName = occupationObject.preCompany.trim();
            }
            if (occupationObject.preOccupation.trim()) {
                preOccupation = occupationObject.preOccupation.trim();
            }
            employerData.previous = {
                address: preAddress,
                employerName: preEmployerName,
                occupation: preOccupation,
                timeAtJob: {
                    timeOnJobsMonths: occupationObject.preJobMonth,
                    timeOnJobsYears: occupationObject.preJobYear,
                },
                employmentType: employerData.current.employmentType,
            };
        }

        setOccupationData(employerData);
    }

    function handlerSubmit() {
        setIsIncomeSubmitted(true);
        if (incomes.length) {
            if (!validaIncomes(incomes)) return;
        } else {
            setValidated(false);
        }

        if (isJointOrCoApp && !validaIncomes(coIncomes)) return;

        const aux = validateOccupation(occupationObject);
        if (aux === false) {
            setValidated(false);
            return;
        }

        if (isJointOrCoApp && !validateOccupation(coOccupation)) {
            setValidated(false);
            return;
        }

        buildAndSetIncomeData();
        setValidated(true);
        setDisabledForm(true);
        setOpen(false);
        setIncomeValid(true);
        buildAndSetOccupationData();
    }

    function selectEmploymentType(occpObject: IOccupation) {
        if (occpObject.retired && occpObject.selfEmployed)
            return 'SelfEmployedRetired';
        else if (occpObject.retired) return 'Retired';
        else if (occpObject.selfEmployed) return 'SelfEmployed';
        else return 'Employed';
    }

    function validateOccupation(value: IOccupation) {
        const {
            retired,
            city,
            country,
            code,
            occupation,
            jobYear,
            jobMonth,
            address,
            addressSecondary,
            company,
            setErrorCompany,
            setErrorAddress,
            setErrorAddressSecondary,
            setErrorCity,
            setErrorCode,
            setErrorOcuppation,
            setErrorJobYear,
            setErrorJobMonth,
            preCity,
            preCountry,
            preCode,
            preOccupation,
            preJobYear,
            preJobMonth,
            preAddress,
            preAddressSecondary,
            preCompany,
            setErrorPreCompany,
            setErrorPreAddress,
            setErrorPreAddressSecondary,
            setErrorPreCity,
            setErrorPreCode,
            setErrorPreOcuppation,
            setErrorPreJobYear,
            setErrorPreJobMonth,
        } = value;
        const validatePreviousEmployer =
            typeof jobYear === 'number' && jobYear < NUMBER_TWO;

        function validate(func: Function, value: string, top = Number('30')) {
            if (value?.length && value !== ' ') {
                const aux = validateLengthNumber(value.trim(), top);
                if (!aux) {
                    func(false);
                    return getTrue();
                } else {
                    func(true);
                    return false;
                }
            } else {
                func(true);
                return false;
            }
        }

        function validateFieldRequired(
            func: Function,
            value: string,
            top = Number('30'),
        ) {
            if (value) {
                const aux =
                    validateLengthNumber(value.trim(), top) ||
                    validateRequired(value.trim());
                if (!aux) {
                    func(false);
                    return getTrue();
                } else {
                    func(true);
                    return false;
                }
            } else {
                func(true);
                return false;
            }
        }

        function validateFieldOptional(
            func: Function,
            value: string,
            top = Number('30'),
        ) {
            if (!value.trim()) {
                func(false);
                return true;
            }
            return validate(func, value.trim(), top);
        }

        function validateZip(
            zipCountry: string,
            func: Function,
            value: string,
        ) {
            if (!value.trim()) {
                func(false);
                return true;
            }
            if (zipCountry.includes('USA')) {
                const aux = validateZipUSA(value);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            } else {
                const aux = validateZipCanada(value);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            }
        }

        function validateYear(func: Function, year: number) {
            if (year || year === Number('0')) {
                const aux = validateJobYear(year);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            } else {
                func(true);
                return false;
            }
        }

        function validateMonth(func: Function, month: number) {
            if (month || month === Number('0')) {
                const aux = validateJobMonth(month);
                if (aux) {
                    func(true);
                    return false;
                } else {
                    func(false);
                    return getTrue();
                }
            } else {
                func(true);
                return false;
            }
        }

        const spectrum: any[] = [];
        const isCompanyValid = validateCompanyName(company);
        const isPreCompanyValid = validateCompanyName(preCompany);
        if (retired) {
            setErrorCompany(false);
            setErrorAddress(false);
            setErrorAddressSecondary(false);
            setErrorCity(false);
            setErrorOcuppation(false);
            setErrorCode(false);
            setErrorJobYear(false);
            setErrorJobMonth(false);
            if (company?.length && company !== ' ') {
                setErrorCompany(!isCompanyValid);
                spectrum.push(isCompanyValid);
            }

            if (address?.length && address !== ' ') {
                spectrum.push(
                    validate(setErrorAddress, address, ADDRESS_NUMBER),
                );
            }

            if (addressSecondary?.length && addressSecondary !== ' ') {
                spectrum.push(
                    validate(
                        setErrorAddressSecondary,
                        addressSecondary,
                        ADDRESS_NUMBER2,
                    ),
                );
            }

            if (city?.length && city !== ' ') {
                spectrum.push(validate(setErrorCity, city));
            }

            if (occupation?.length && occupation !== ' ') {
                spectrum.push(
                    validate(setErrorOcuppation, occupation, Number('20')),
                );
            }

            if (code?.length && code !== ' ') {
                if (country.includes('USA')) {
                    const aux = validateZipUSA(code);
                    if (aux) {
                        setErrorCode(true);
                        spectrum.push(false);
                    } else {
                        setErrorCode(false);
                        spectrum.push(getTrue());
                    }
                } else {
                    const aux = validateZipCanada(code);
                    if (aux) {
                        setErrorCode(true);
                        spectrum.push(false);
                    } else {
                        setErrorCode(false);
                        spectrum.push(getTrue());
                    }
                }
            }

            if (jobYear) {
                const aux = validateJobYear(jobYear);
                if (aux) {
                    setErrorJobYear(true);
                    spectrum.push(false);
                } else {
                    setErrorJobYear(false);
                    spectrum.push(getTrue());
                }
            }

            if (jobMonth) {
                const aux = validateJobMonth(jobMonth);
                if (aux) {
                    setErrorJobMonth(true);
                    spectrum.push(false);
                } else {
                    setErrorJobMonth(false);
                    spectrum.push(getTrue());
                }
            }

            if (validatePreviousEmployer) {
                setErrorPreCompany(!isPreCompanyValid);
                spectrum.push(isPreCompanyValid);
                spectrum.push(
                    validateFieldOptional(
                        setErrorPreAddress,
                        preAddress,
                        ADDRESS_NUMBER,
                    ),
                );
                if (
                    preAddressSecondary?.length &&
                    preAddressSecondary !== ' '
                ) {
                    spectrum.push(
                        validate(
                            setErrorPreAddressSecondary,
                            preAddressSecondary,
                            ADDRESS_NUMBER2,
                        ),
                    );
                }
                spectrum.push(validateFieldOptional(setErrorPreCity, preCity));
                spectrum.push(
                    validate(
                        setErrorPreOcuppation,
                        preOccupation,
                        Number('20'),
                    ),
                );
                spectrum.push(
                    validateZip(preCountry, setErrorPreCode, preCode),
                );

                const fieldJobYear = validateJobYear(preJobYear);
                if (fieldJobYear) {
                    setErrorPreJobYear(true);
                    spectrum.push(false);
                } else {
                    setErrorPreJobYear(false);
                    spectrum.push(getTrue());
                }

                const fieldPreJobMonth = validateJobMonth(preJobMonth);
                if (fieldPreJobMonth) {
                    setErrorPreJobMonth(true);
                    spectrum.push(false);
                } else {
                    setErrorPreJobMonth(false);
                    spectrum.push(getTrue());
                }
            }
            const value = spectrum.find((ele) => ele === false);
            if (spectrum.length) return value === undefined ? true : value;
            else return true;
        } else {
            setErrorCompany(!isCompanyValid);
            const fieldCompany = isCompanyValid;
            const fieldAddress = validateFieldOptional(
                setErrorAddress,
                address,
                ADDRESS_NUMBER,
            );
            const fieldCity = validateFieldOptional(setErrorCity, city);
            const fieldOccupation = validateFieldRequired(
                setErrorOcuppation,
                occupation,
            );
            setErrorJobYear(validateRequired(jobYear));
            setErrorJobMonth(validateRequired(jobMonth));
            const fieldCode = validateZip(country, setErrorCode, code);
            const fieldYear =
                typeof jobYear === 'number' &&
                !validateRequired(jobYear) &&
                validateYear(setErrorJobYear, jobYear);
            const fieldMonth =
                typeof jobMonth === 'number' &&
                !validateRequired(jobMonth) &&
                validateMonth(setErrorJobMonth, jobMonth);

            const validCurrentEmployer =
                fieldCompany &&
                fieldAddress &&
                fieldOccupation &&
                fieldMonth &&
                fieldCity &&
                fieldCode &&
                fieldYear;

            if (validatePreviousEmployer) {
                setErrorPreCompany(!isPreCompanyValid);
                const fieldPreCompany = isPreCompanyValid;
                const fieldPreAddress = validateFieldOptional(
                    setErrorPreAddress,
                    preAddress,
                    ADDRESS_NUMBER,
                );
                const fieldPreCity = validateFieldOptional(
                    setErrorPreCity,
                    preCity,
                );
                const fieldPreOccupation = validateFieldRequired(
                    setErrorPreOcuppation,
                    preOccupation,
                );
                const fieldPreCode = validateZip(
                    preCountry,
                    setErrorPreCode,
                    preCode,
                );
                const fieldPreYear =
                    !validateRequired(preJobYear) &&
                    validateYear(setErrorPreJobYear, preJobYear);
                const fieldPreMonth =
                    !validateRequired(preJobMonth) &&
                    validateMonth(setErrorPreJobMonth, preJobMonth);

                const validPreviousEmployer =
                    fieldPreCompany &&
                    fieldPreAddress &&
                    fieldPreOccupation &&
                    fieldPreMonth &&
                    fieldPreCity &&
                    fieldPreCode &&
                    fieldPreYear;

                return validCurrentEmployer && validPreviousEmployer;
            }
            return validCurrentEmployer;
        }
    }

    function getTrue() {
        setValidated(true);
        return true;
    }

    function validaIncomes(values: IIncome[]) {
        for (const i of values) {
            if (i.error || i.amount === null || i.amount < NUMBER_ZERO) {
                setValidated(false);
                return false;
            }
        }
        return true;
    }

    const onEdit = () => {
        setDisabledForm(false);
        setIncomeValid(false);
        if (isEditMode) {
            disablePrintAndSubmitBtn(true);
        }
    };

    useEffect(() => {
        if (isEditMode) {
            const isIndividualAndDataUpdated =
                !isJointOrCoApp &&
                isIncomeFieldValueUpdated &&
                isOccupationFieldValueUpdated;
            const isJointOrCoAppAndDataUpdated =
                isJointOrCoApp &&
                isIncomeFieldValueUpdated &&
                isOccupationFieldValueUpdated &&
                isCoAppIncomeFieldValueUpdated &&
                isCoAppOccupationFieldValueUpdated;
            if (isIndividualAndDataUpdated || isJointOrCoAppAndDataUpdated) {
                buildAndSetIncomeData();
                buildAndSetOccupationData();
            }
        }
    }, [
        isEditMode,
        isIncomeFieldValueUpdated,
        isOccupationFieldValueUpdated,
        isCoAppIncomeFieldValueUpdated,
        isCoAppOccupationFieldValueUpdated,
    ]);

    return (
        <FormSectionPage
            title={occupationIndividualInformation.OCCUPATION_INCOME_LABEL}
            handlerSubmit={handlerSubmit}
            showIcon={validated}
            isOpen={isOpen}
            setOpen={setOpen}
            isDisabled={disabledForm}
            onEdit={onEdit}
            isEditMode={isEditMode}
            isBlocked={isBlocked}
            disablePrintAndSubmitBtn={disablePrintAndSubmitBtn}
        >
            <fieldset disabled={disabledForm}>
                {isJointOrCoApp ? (
                    <>
                        <div>
                            <div className='o-fieldset__row mb-0'>
                                <div className='o-layout'>
                                    <div className='o-layout__item  u-1/1  u-1/1@xs '>
                                        <h6 className='section-title'>
                                            {
                                                occupationIndividualInformation.PRIMARY_APP
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <Income
                                handlerChangeItems={handlerChangeIncomes}
                                isDisabled={disabledForm}
                                incomeError={isIncomeSubmitted}
                                initialIncomes={
                                    initialPrimaryApplicant?.Incomes?.value ??
                                    null
                                }
                                isEditMode={isEditMode}
                                setFieldValueUpdated={
                                    setIsIncomeFieldValueUpdated
                                }
                            ></Income>
                            <br />
                            <Company
                                handlerChange={handlerChangeCompany}
                                isDisabled={disabledForm}
                                initialPrimaryApplicant={
                                    initialPrimaryApplicant ?? null
                                }
                                isEditMode={isEditMode}
                                setFieldValueUpdated={
                                    setIsOccupationFieldValueUpdated
                                }
                            ></Company>
                        </div>
                        <br />
                        <br />
                        <div>
                            <div className='o-fieldset__row mb-0'>
                                <div className='o-layout'>
                                    <div className='o-layout__item  u-1/1  u-1/1@xs '>
                                        <h6 className='section-title'>
                                            {applicationType.includes(
                                                CreditApplicationType.JOINT,
                                            )
                                                ? occupationIndividualInformation.JOINT_APP
                                                : occupationIndividualInformation.CO_APP}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <Income
                                handlerChangeItems={handlerChangeCoIncomes}
                                isDisabled={disabledForm}
                                incomeError={isIncomeSubmitted}
                                initialIncomes={
                                    initialJointOrCoApplicant?.Incomes?.value ??
                                    null
                                }
                                isEditMode={isEditMode}
                                setFieldValueUpdated={
                                    setIsCoAppIncomeFieldValueUpdated
                                }
                            ></Income>
                            {}
                            <br />
                            <Company
                                handlerChange={handlerChangeCoCompany}
                                isDisabled={disabledForm}
                                initialPrimaryApplicant={
                                    initialJointOrCoApplicant ?? null
                                }
                                isEditMode={isEditMode}
                                setFieldValueUpdated={
                                    setIsCoAppOccupationFieldValueUpdated
                                }
                            ></Company>
                        </div>
                    </>
                ) : (
                    <>
                        <Income
                            handlerChangeItems={handlerChangeIncomes}
                            isDisabled={disabledForm}
                            incomeError={isIncomeSubmitted}
                            initialIncomes={
                                initialPrimaryApplicant?.Incomes?.value ?? null
                            }
                            isEditMode={isEditMode}
                            setFieldValueUpdated={setIsIncomeFieldValueUpdated}
                        ></Income>
                        <br />
                        <Company
                            handlerChange={handlerChangeCompany}
                            isDisabled={disabledForm}
                            initialPrimaryApplicant={
                                initialPrimaryApplicant ?? null
                            }
                            isEditMode={isEditMode}
                            setFieldValueUpdated={
                                setIsOccupationFieldValueUpdated
                            }
                        ></Company>
                    </>
                )}
            </fieldset>
        </FormSectionPage>
    );
};

export default IndividualOccupationIncome;
